var _g, _rect, _rect2, _rect3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcome3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 349,
    viewBox: "0 0 360 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_57_14250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.79199 27.2737H362.013V273.811H-7.79199V27.2737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.068 130.801C290.337 134.14 281.404 129.847 281.404 129.847C281.404 129.847 283.389 120.142 290.123 116.808C296.854 113.47 305.784 117.758 305.784 117.758C305.784 117.758 303.798 127.463 297.068 130.801Z",
    fill: "url(#paint0_linear_57_14250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.268 105.03C285.84 107.227 281.765 105.606 275.922 101.723C271.528 98.8015 267.488 96.1998 264.203 91.2008C261.903 87.7033 260.611 83.9428 259.976 80.6211C259.288 77.0221 257.985 72.639 260.897 70.5283C264.897 67.6294 277.699 70.2213 285.541 81.3385C294.155 93.5524 292.62 102.884 289.268 105.03Z",
    fill: "url(#paint1_linear_57_14250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.694 188.024C76.5936 193.358 89.3618 188.427 89.3618 188.427C89.3618 188.427 87.6923 174.85 78.7874 169.522C69.8878 164.188 57.125 169.113 57.125 169.113C57.125 169.113 58.7945 182.69 67.694 188.024Z",
    fill: "url(#paint2_linear_57_14250)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.445 151C293.418 151 290.153 154.265 290.153 158.292C290.153 162.32 293.418 165.584 297.445 165.584C301.472 165.584 304.737 162.32 304.737 158.292C304.737 154.265 301.472 151 297.445 151Z",
    fill: "#FD6B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.2546 131.437C77.9392 131.437 75.2515 134.124 75.2515 137.44C75.2515 140.755 77.9392 143.443 81.2546 143.443C84.5701 143.443 87.2578 140.755 87.2578 137.44C87.2578 134.124 84.5701 131.437 81.2546 131.437Z",
    fill: "#FD6B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3723 221.016C88.5966 221.016 85.5358 217.955 85.5358 214.179C85.5358 210.404 88.5966 207.343 92.3723 207.343C96.1479 207.343 99.2087 210.404 99.2087 214.179C99.2087 217.955 96.1479 221.016 92.3723 221.016Z",
    fill: "#FD6B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.673 169.907C317.911 169.907 316.483 168.479 316.483 166.717C316.483 164.955 317.911 163.527 319.673 163.527C321.435 163.527 322.863 164.955 322.863 166.717C322.863 168.479 321.435 169.907 319.673 169.907Z",
    fill: "#FD6B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.262 203.304C271.996 203.304 270.16 201.467 270.16 199.202C270.16 196.936 271.996 195.1 274.262 195.1C276.527 195.1 278.364 196.936 278.364 199.202C278.364 201.467 276.527 203.304 274.262 203.304Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3226 247.583C78.0505 247.583 75.3979 244.931 75.3979 241.659C75.3979 238.386 78.0505 235.734 81.3226 235.734C84.5947 235.734 87.2473 238.386 87.2473 241.659C87.2473 244.931 84.5947 247.583 81.3226 247.583Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.262 246.235C267.771 246.235 265.752 244.216 265.752 241.726C265.752 239.235 267.771 237.216 270.262 237.216C272.752 237.216 274.771 239.235 274.771 241.726C274.771 244.216 272.752 246.235 270.262 246.235Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.653 96.3619C304.884 96.3619 302.64 94.1173 302.64 91.3485C302.64 88.5797 304.884 86.3352 307.653 86.3352C310.422 86.3352 312.667 88.5797 312.667 91.3485C312.667 94.1173 310.422 96.3619 307.653 96.3619Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5166 148.78C42.1601 151.181 40.7348 153.65 38.3331 154.294C35.9313 154.937 33.4626 153.512 32.8191 151.11C32.1755 148.708 33.6008 146.24 36.0026 145.596C38.4043 144.952 40.873 146.378 41.5166 148.78Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.397 89.6365C106.362 89.6365 105.523 88.7976 105.523 87.7628C105.523 86.728 106.362 85.8892 107.397 85.8892C108.432 85.8892 109.271 86.728 109.271 87.7628C109.271 88.7976 108.432 89.6365 107.397 89.6365Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.681 206.39C300.137 206.39 298.074 204.739 298.074 202.704C298.074 200.668 300.137 199.018 302.681 199.018C305.225 199.018 307.288 200.668 307.288 202.704C307.288 204.739 305.225 206.39 302.681 206.39Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.962 56.7189C222.428 58.4576 221.396 60.2447 219.657 60.7106C217.918 61.1765 216.131 60.1447 215.665 58.406C215.199 56.6673 216.231 54.8801 217.97 54.4143C219.709 53.9484 221.496 54.9802 221.962 56.7189Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2167 91.4309H75.282C75.6707 96.9373 79.7657 97.0224 79.7657 97.0224C79.7657 97.0224 75.2504 97.1103 75.2504 103.473C75.2504 97.1103 70.7346 97.0224 70.7346 97.0224C70.7346 97.0224 74.828 96.9373 75.2167 91.4309V91.4309Z",
    fill: "#E1E4E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.783 75.1548L242.673 103.07C245.949 106.349 247.79 110.795 247.791 115.43V225.708C247.791 235.369 239.975 243.19 230.327 243.19H131.705C122.057 243.19 114.241 235.369 114.241 225.708V87.5149C114.241 77.8535 122.057 70.033 131.705 70.033H202.437C204.73 70.034 207.001 70.4869 209.119 71.3657C211.238 72.2445 213.162 73.532 214.783 75.1548V75.1548Z",
    fill: "white",
    stroke: "#E1E4E5",
    strokeWidth: 4.51984
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.828 212.305H212.323M143.913 140.054H178.093H143.913ZM143.913 121.153H178.093H143.913ZM143.913 163.637H204.784H143.913ZM143.828 188.062H212.323H143.828Z",
    stroke: "#E1E4E5",
    strokeWidth: 9.86148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.307 126.559V87.4538C294.308 80.7237 290.072 74.7156 283.716 72.4343L259.281 63.6716C250.859 60.6518 241.65 60.6518 233.228 63.6716L208.762 72.4503C202.411 74.7296 198.176 80.7295 198.171 87.4538V126.559C198.171 146.877 226.707 161.912 239.829 167.771C241.845 168.677 244.029 169.145 246.239 169.145C248.448 169.145 250.633 168.677 252.648 167.771C265.771 161.913 294.307 146.845 294.307 126.559V126.559Z",
    fill: "#6200EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.826 139.859H248.505C249.567 139.859 250.449 138.991 250.449 137.916V133.422L251.421 133.163C259.353 131.169 262.166 125.717 262.166 121.663C262.166 114.151 255.685 111.03 249.334 108.958C243.372 106.99 241.467 105.798 241.467 104.037C241.467 102.457 243.294 100.876 247.39 100.876C251.901 100.876 254.726 102.158 255.931 102.715C256.191 102.832 256.463 102.897 256.735 102.897C257.486 102.897 258.173 102.457 258.497 101.783L260.351 97.8585C260.571 97.4053 260.597 96.8613 260.416 96.382C260.247 95.8896 259.884 95.501 259.418 95.2809C257.188 94.232 254.765 93.5581 252.03 93.2348L250.889 93.0924V89.1942C250.889 88.1323 250.02 87.2644 248.945 87.2644H244.343C243.281 87.2644 242.399 88.1323 242.399 89.1942V93.5326L241.427 93.7788C235.024 95.3978 231.201 99.503 231.201 104.748C231.201 111.665 238.057 114.746 244.784 116.858C250.992 118.878 251.835 120.627 251.835 122.077C251.835 124.318 248.932 125.949 244.94 125.949C241.544 125.949 237.889 125.081 235.167 123.631C234.882 123.475 234.571 123.398 234.246 123.398C234.039 123.398 233.831 123.437 233.624 123.501C233.119 123.683 232.704 124.059 232.484 124.55L230.695 128.526C230.293 129.446 230.63 130.508 231.511 131C233.779 132.308 237.149 133.279 240.727 133.681L241.88 133.798V137.916C241.881 138.991 242.75 139.859 243.826 139.859Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 161,
    y: 288.833,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#6200EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 172,
    y: 288.833,
    width: 5,
    height: 5,
    rx: 2.5,
    fill: "#6200EA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 288.833,
    width: 16,
    height: 5,
    rx: 2.5,
    fill: "#6200EA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_57_14250",
    x1: 271.221,
    y1: 141.216,
    x2: 326.736,
    y2: 97.3032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_57_14250",
    x1: 266.603,
    y1: 119.027,
    x2: 288.478,
    y2: 40.3509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_57_14250",
    x1: 102.133,
    y1: 205.193,
    x2: 30.5236,
    y2: 138.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_57_14250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 297,
    height: 249.666,
    fill: "white",
    transform: "translate(31.5 39.1672)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome3);
export default __webpack_public_path__ + "static/media/welcome3.5f2b8d0d.svg";
export { ForwardRef as ReactComponent };